import * as Actions from './UserActions';

const initialState = {
  appReady: false,
  user: null,
  entitlements: {
    isWdcEnabled: true,
    classicFrontendExperience: true,
    canToggleFrontendExperience: true,
    isOrganizerReportGenerationAllowed: true,
    isRestrictReportDownloadEnabled: false
  },
  error: null,
  darkMode: false,
  isSettingsFetched: false
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case Actions.GET_USER_REQUEST: {
      return { ...state };
    }
    case Actions.GET_USER_SUCCESS: {
      return { ...state, user: action.payload.user };
    }
    case Actions.GET_USER_FAILURE: {
      return { ...state, error: action.error };
    }
    case Actions.APP_READY: {
      return { ...state, appReady: true };
    }
    case Actions.APP_LOGOUT_REQUEST: {
      return { ...state, appReady: false };
    }
    case Actions.GET_USER_SETTINGS_SUCCESS: {
      return {
        ...state,
        entitlements: { ...state.entitlements, ...action.payload.entitlements },
        isSettingsFetched: true
      };
    }
    case Actions.GET_USER_SETTINGS_FAILURE: {
      return { ...state, isSettingsFetched: true, error: action.error };
    }
    case Actions.GET_USER_DARK_MODE_CONFIG: {
      return { ...state, darkMode: action.payload.darkMode };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Reducks/User/UserReducer.js